import React from 'react';
import './StoreLaunchKit.css';

const StoreLaunchKit = () => {
  const blocks = [
    {
      id: "01",
      title: "Store Pages",
      description: "Homepage, shop, category, product detail, cart, checkout, and order confirmation.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z" />
          <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
          <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
        </svg>
      ),
      tags: ["Home", "Shop", "Product", "Cart", "Checkout"],
      gradient: "gradient-primary",
      bgColor: "bg-primary"
    },
    {
      id: "02",
      title: "Product Setup",
      description: "Up to 25 products, 4 categories, 3 variants per product, and 5 images per product.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
          <path d="M12 22V12" />
          <polyline points="3.29 7 12 12 20.71 7" />
          <path d="m7.5 4.27 9 5.15" />
        </svg>
      ),
      tags: ["25 products", "4 categories", "3 variants", "5 images"],
      gradient: "gradient-coral",
      bgColor: "bg-coral"
    },
    {
      id: "03",
      title: "Sales Features",
      description: "Add to cart, buy now, promo codes, badges, COD, online payment, WhatsApp inquiry.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
          <path d="M20 2v4" />
          <path d="M22 4h-4" />
          <circle cx="4" cy="20" r="2" />
        </svg>
      ),
      tags: ["Add to cart", "Promo", "COD", "Online", "WhatsApp"],
      gradient: "gradient-primary",
      bgColor: "bg-accent"
    },
    {
      id: "04",
      title: "Trust Pages",
      description: "About, Contact, FAQs, Shipping, Returns, Privacy & Terms — fully ready.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      ),
      tags: ["About", "FAQs", "Returns", "Privacy", "Terms"],
      gradient: "gradient-coral",
      bgColor: "bg-foreground"
    }
  ];

  return (
    <section id="included" className="store-launch-kit">
      <div className="grid-pattern"></div>

      <div className="container-px">
        {/* Header Section */}
        <div className="text-center max-w-2xl mx-auto">
          <div className="flex justify-center">
            <span className="badge-sparkle">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                <path d="M20 2v4" />
                <path d="M22 4h-4" />
                <circle cx="4" cy="20" r="2" />
              </svg>
              What's Included
            </span>
          </div>

          <h2 className="section-title-launch">
            Your Complete <span className="text-gradient">Store Launch Kit</span>
          </h2>

          <p className="section-description-launch">
            Four building blocks that come together to form your full online store ready to launch.
          </p>
        </div>

        {/* Main Content */}
        <div className="main-content-wrapper">
          {/* Floating Elements */}
          <div className="floating-elements">
            <div className="float-element float-1 animate-float-slow">
              <div className="float-card rotate-[-6deg]">
                <div className="float-img-wrapper">
                  <img src="https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=480&q=80" alt="Product" />
                </div>
              </div>
            </div>

            <div className="float-element float-2 animate-float-delayed">
              <div className="float-card-small rotate-[6deg]">
                <div className="cart-mini">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="8" cy="21" r="1" />
                    <circle cx="19" cy="21" r="1" />
                    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                  </svg>
                  Cart · 3 items
                </div>
                <p className="price-mini">PKR 12,390</p>
              </div>
            </div>

            <div className="float-element float-3 animate-float-tiny">
              <div className="float-card-small rotate-[-5deg]">
                <div className="order-mini">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  Order #2384
                </div>
                <p className="confirmed-mini">Confirmed · COD</p>
              </div>
            </div>

            <div className="float-element float-4 animate-float-slow">
              <div className="float-card-tiny rotate-[4deg]">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                  <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                  <path d="M10 9H8" />
                  <path d="M16 13H8" />
                  <path d="M16 17H8" />
                </svg>
                <span>Return Policy.pdf</span>
              </div>
            </div>

            <div className="float-element float-5 animate-float-delayed">
              <div className="payment-badge rotate-[-3deg]">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="14" x="2" y="5" rx="2" />
                  <line x1="2" x2="22" y1="10" y2="10" />
                </svg>
                Payment ready
              </div>
            </div>

            <div className="center-store">
              <div className="store-glow"></div>
              <div className="store-circle">
                <div className="store-content">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5" />
                    <path d="M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244" />
                    <path d="M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05" />
                  </svg>
                  <p>YOUR<br />STORE</p>
                </div>
              </div>
            </div>
          </div>

          {/* Cards Grid */}
          <div className="cards-grid">
            {blocks.map((block, index) => (
              <div key={index} className={`feature-block ${index === 1 ? 'lg:translate-y-10 lg:rotate-1' : index === 2 ? 'lg:translate-y-4 lg:rotate-1' : index === 3 ? 'lg:translate-y-14 lg:-rotate-1' : 'lg:-translate-y-0 lg:-rotate-1'}`}>
                <div className={`block-card ${block.gradient}`}>
                  <span className="block-number">Block {block.id}</span>

                  <div className="block-content">
                    <span className={`block-icon ${block.bgColor}`}>
                      {block.icon}
                    </span>

                    <div className="block-text">
                      <h3>{block.title}</h3>
                      <p>{block.description}</p>
                    </div>
                  </div>

                  <div className="block-tags">
                    {block.tags.map((tag, idx) => (
                      <span key={idx} className="kit-tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Note */}
        <p className="footer-note">
          Banners must be provided by the client. Banner design, product image editing, copywriting,
          or extra products/categories can be added as add-ons.
        </p>
      </div>
    </section>
  );
};

export default StoreLaunchKit;